module.exports = __webpack_public_path__ + "media/journey_sweepstakes/scholarship-journey-landing-map-b60cb9a6.gif";